const STORAGE_KEY = 'saved_accounts';
const MAX_ACCOUNTS = 10;

export const getAccountId = (userData) =>
  `${userData?.schoolCode || ''}:${userData?.username || userData?.email || ''}`;

export const getSavedAccounts = () => {
  try {
    const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

const writeAccounts = (list) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ACCOUNTS)));
  window.dispatchEvent(new Event('saved-accounts:changed'));
};

// userData is the login response `data` object (without the token).
export const saveAccount = (userData, token) => {
  if (!userData || !token) return;
  const id = getAccountId(userData);
  const entry = { id, token, userData, savedAt: Date.now() };
  writeAccounts([entry, ...getSavedAccounts().filter((a) => a.id !== id)]);
};

export const removeAccount = (id) => writeAccounts(getSavedAccounts().filter((a) => a.id !== id));

// Tokens get refreshed by the API layer, so keep the saved copy of the active account current.
export const syncActiveAccountToken = () => {
  const token = localStorage.getItem('token');
  let active = null;
  try {
    active = JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return;
  }
  if (!token || !active) return;
  const id = getAccountId(active);
  const list = getSavedAccounts();
  if (list.some((a) => a.id === id)) {
    writeAccounts(list.map((a) => (a.id === id ? { ...a, token } : a)));
  }
};

export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.exp ? payload.exp * 1000 <= Date.now() + 5000 : false;
  } catch {
    return false;
  }
};
